/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InputAdresss,
    InputAdresssFromJSON,
    InputAdresssToJSON,
    SuggestedAddresses,
    SuggestedAddressesFromJSON,
    SuggestedAddressesToJSON,
} from '../models';

export interface SuggestSmartformAddressRequest {
    inputAdresss: InputAdresss;
}

/**
 * AddressApi - interface
 * 
 * @export
 * @interface AddressApiInterface
 */
export interface AddressApiInterface {
    /**
     * This public view handle address suggestion. For address validation we use smartform.cz web service.
     * @param {InputAdresss} inputAdresss 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApiInterface
     */
    suggestSmartformAddressRaw(requestParameters: SuggestSmartformAddressRequest): Promise<runtime.ApiResponse<SuggestedAddresses>>;

    /**
     * This public view handle address suggestion. For address validation we use smartform.cz web service.
     */
    suggestSmartformAddress(requestParameters: SuggestSmartformAddressRequest): Promise<SuggestedAddresses>;

}

/**
 * 
 */
export class AddressApi extends runtime.BaseAPI implements AddressApiInterface {

    /**
     * This public view handle address suggestion. For address validation we use smartform.cz web service.
     */
    async suggestSmartformAddressRaw(requestParameters: SuggestSmartformAddressRequest): Promise<runtime.ApiResponse<SuggestedAddresses>> {
        if (requestParameters.inputAdresss === null || requestParameters.inputAdresss === undefined) {
            throw new runtime.RequiredError('inputAdresss','Required parameter requestParameters.inputAdresss was null or undefined when calling suggestSmartformAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/address/suggest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InputAdresssToJSON(requestParameters.inputAdresss),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SuggestedAddressesFromJSON(jsonValue));
    }

    /**
     * This public view handle address suggestion. For address validation we use smartform.cz web service.
     */
    async suggestSmartformAddress(requestParameters: SuggestSmartformAddressRequest): Promise<SuggestedAddresses> {
        const response = await this.suggestSmartformAddressRaw(requestParameters);
        return await response.value();
    }

}
